<template>
  <!-- ナビゲーションドロワーコンポーネント -->
  <div class="d-flex w-100 border-b-md" :class="getHeaderColorClass()">
    <AppDrawer v-model="drawer" />

    <div class="left-section ml-4 d-flex align-center justify-left">
      <router-link v-if="loginUser?.proxyLoginMode !== 'CH'" to="/" class="logo-link">
        <v-avatar size="3rem" class="logo-avatar">
          <v-img src="~/assets/images/logo/jrf_logo.png" alt="Logo Icon" class="jrf-logo" />
        </v-avatar>
      </router-link>
      <div v-else class="logo-link">
        <v-avatar size="3rem" class="logo-avatar">
          <v-img src="~/assets/images/logo/jrf_logo.png" alt="Logo Icon" class="jrf-logo" />
        </v-avatar>
      </div>
      <div class="text-logo-wrapper">
        <span v-if="appEnv === 'staging'">テスト環境（保守）<br /></span>
        <span v-if="appEnv === 'develop'">テスト環境（開発）<br /></span>
        <span v-if="appEnv === 'training'">テスト環境（習熟）<br /></span>
        <span class="font-bold">{{ displayUserName }}</span>
      </div>
    </div>

    <v-spacer />

    <div class="right-section mr-4 justify-right d-flex align-center">
      <CustomButton
        variant="outlined"
        size="sm"
        color="primary"
        class="custom-size-button"
        @click="onMenuClick"
      >
        メニュー
      </CustomButton>
    </div>
  </div>
</template>

<script setup>
import AppDrawer from '~/components/layout/AppDrawer.vue';
import CustomButton from '~/components/common/parts/CustomButton.vue';

const { displayUserName, loginUser } = storeToRefs(useLoginUserStore());
const { appEnv } = useRuntimeConfig().public;

// ドロワーの表示状態
const drawer = ref(false);

// ドロワーの表示/非表示を切り替える
const toggleDrawer = () => {
  drawer.value = !drawer.value;
};

const onMenuClick = () => {
  toggleDrawer();
};

const getHeaderColorClass = () => {
  switch (appEnv) {
    case 'staging':
      return 'bg-color-stg';
    case 'develop':
      return 'bg-color-dev';
    case 'training':
      return 'bg-color-training';
    default:
      return 'background-bg';
  }
};
</script>

<style lang="scss" scoped>
@use '~/assets/scss/_base.scss' as vars;

.btn {
  color: vars.$color-primary;
}
</style>

<style lang="scss" scoped>
.custom-size-button {
  width: 96px;  // 幅を指定
  height: 44px; // 高さを指定
}

.logo-avatar,
.jrf-logo {
  background-color: inherit;
}
</style>
